var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.misc.showLoader)?_c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader"}),_c('span',{staticClass:"loader-text"},[_vm._v("Bezig met verwerken")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }